import { render, staticRenderFns } from "./buyAlone.vue?vue&type=template&id=135adc35&"
import script from "./buyAlone.vue?vue&type=script&lang=js&"
export * from "./buyAlone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports